import React from 'react';

import Unauthenticated from 'Components/Layouts/Unauthenticated';
import { PrimaryButton } from "Components/Button";
import BigYellowButton from "Components/Button/BigYellowButton";
import TitleText from "Components/Utilities/TitleText";

import { asset } from "Services/BaseHelpers";

export default class HowToPlay extends React.Component {
    /**
     * @var topBlocks
     * @type {array}
     */
    topBlocks = [
        {
            image: 'norton.png',
            text: <div>
                <span className="text-app-yellow">
                    Collect{" "}
                </span>

                The Norton 'Protection Shields'
            </div>,
        },
        {
            image: 'virus.png',
            text: <div>
                <span className="text-app-yellow">
                    Avoid{" "}
                </span>

                The 'Vicious Viruses'
            </div>,
        },
        {
            image: 'hacker-man.png',
            text: <div>
                <span className="text-app-yellow">
                    Avoid{" "}
                </span>

                The 'Cybercrook'
            </div>,
        }
    ]

    /**
     * @var bottomBlocks
     * @type {array}
     */
    bottomBlocks = [
        {
            image: 'mobile',
            text: 'YOUR MOBILE',
        },
        {
            image: 'laptop',
            text: 'YOUR LAPTOP',
        },
        {
            image: 'person',
            text: 'YOUR IDENTITY',
        }
    ]

    /**
     * @var howToPlay
     * @type {array}
     */
    howToPlay = [
        `
            Protect the device from being accessed by malicious cybercrooks and
            vicious viruses by patrolling the device system
            and collecting the Protection shields
        `,
        'Each time the Norton Protection Shields are collected the threat is neutralised',
        'Once all protection-shields are collected and threats avoided, the system is safe',
        'Bonus points are awarded for completing the game in a quicker time',
        'Avoid coming into contact with the Cybercrooks & Virus directly, three times and its game over'
    ];


    /**
     * @method render
     * @return {*}
     */
    render () {
        const {setParentState, protectingImage} = this.props;

        return (
            <div className="h-full overflow-y-auto">
                <TitleText
                    subtitle="Get Ready"
                    title="How To Play"
                />

                <div className={`
                    flex flex-col lg:flex-row justify-center items-center gap-2 lg:gap-6 text-center mx-auto my-8
                    text-xs md:text-xs uppercase rubrik-light text-white tracking-wide font-thin
                `}>
                    {this.topBlocks.map((block, i) => (
                        <div
                            className="flex flex-row justify-center items-center gap-2"
                            key={i}
                        >
                            <div>
                                {block.text}
                            </div>

                            <img
                                src={asset(`images/pacman/${block.image}`)}
                                className="h-8"
                            />
                        </div>
                    ))}
                </div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                    <div className="bg-app-black w-full p-4 rounded-lg">
                        <div className="text-app-yellow retro-gaming text-sm md:text-lg text-center lg:text-left uppercase mb-3">
                            How to Play
                        </div>

                        <ul className="text-white rubrik-light list-disc pl-5 text-sm space-y-3 justify-center">
                           {this.howToPlay.map((text, i) => (
                                <li key={i}>
                                    {text}
                                </li>
                            ))}
                       </ul>
                    </div>

                    <div className="w-full p-4">
                        <div className="text-app-yellow retro-gaming text-lg uppercase text-center lg:text-left md:text-center">
                            What do you want to protect?
                        </div>

                        <div className={`
                            flex flex-col md:flex-row justify-center items-center md:items-end gap-6 text-center mx-auto my-8
                            text-xs md:text-xs uppercase retro-gaming text-white
                        `}>
                            {this.bottomBlocks.map((block, i) => (
                                <div
                                    className="flex flex-col justify-between items-center gap-4 cursor-pointer"
                                    onClick={() => setParentState({
                                        protectingImage: block.image
                                    })}
                                    key={i}
                                >
                                    <img
                                        src={asset(`/images/pacman/protecting-images/${protectingImage === block.image ? block.image + '-border' : block.image}.png`)}
                                    />

                                    {block.text}
                                </div>
                            ))}
                        </div>

                        <BigYellowButton
                            className="mx-auto"
                            text="Play Now"
                            onClick={() => setParentState({
                                stage: 'game'
                            })}
                        />
                    </div>
                </div>
            </div>
        );
    }
}
